import React, { useState, useEffect } from 'react';
import { Space, Collapse, Spin, Typography } from 'antd';
import PropTypes from 'prop-types';
import FeatherIcon from 'feather-icons-react';
import { ModalSelectCustomItem } from './modalSelectCustomItem';
import { PanelButton, CollapseContainer } from './style';
import { useCustomListField } from './hooks/useCustomListField';
import { CustomListsService } from '../../../../services/customListService';
import { useIncidentFormContext } from '../../context/incidentFormContext';

const { Text } = Typography;

export const CustomListField = ({
  field,
  onChange,
  readOnly,
  getListRoot,
  getListItems,
  disabled,
  extendedFormEnabled,
}) => {
  const incidentFormContext = useIncidentFormContext();
  const listId = field.typeSelected.id ?? field.typeSelected;
  const [showModal, setShowModal] = useState(false);
  const [showPanel, setShowPanel] = useState(false);
  const {
    isLoading,
    listRoot,
    value: listValue,
    legacyValue,
    setValue,
  } = useCustomListField({
    listId,
    defaultValue: field.value?.nodes,
    getRoot: getListRoot ?? incidentFormContext?.getListRoot,
  });

  useEffect(() => {
    if (listValue?.length) setShowPanel(true);
  }, [listValue]);

  const onClick = () => {
    setShowModal(true);
  };

  const closeModal = (selectedValue) => {
    if (selectedValue) {
      setShowPanel(true);
      setValue(selectedValue);
      if (onChange) onChange({ ...listRoot, nodes: selectedValue });
    }
    setShowModal(false);
  };

  const switchPanel = (e) => {
    e.stopPropagation();
    setShowPanel(!showPanel);
  };

  return (
    <>
      {readOnly ? (
        <Text>
          <b>{field.label}: </b>
          {extendedFormEnabled ? (
            <ul>
              {legacyValue?.map((item, index) => (
                <li key={index}>{item.join(' > ')}</li>
              ))}
            </ul>
          ) : (
            legacyValue?.map((item) => item.join(' > ')).join(', ')
          )}
        </Text>
      ) : (
        <CollapseContainer>
          <Collapse activeKey={showPanel ? [field.idInput] : []}>
            <Collapse.Panel
              header={listValue.length ? `${listRoot?.title ?? ''} (${listValue.length})` : `${listRoot?.title ?? ''}`}
              key={field.idInput}
              showArrow={false}
              extra={
                <Spin spinning={isLoading}>
                  <Space size="small">
                    <PanelButton size="small" type="secondary" onClick={switchPanel} disabled={disabled}>
                      <FeatherIcon icon={showPanel ? 'chevron-up' : 'chevron-down'} />
                    </PanelButton>
                    <PanelButton size="small" type="primary" onClick={onClick} disabled={disabled}>
                      <FeatherIcon icon="plus" />
                    </PanelButton>
                  </Space>
                </Spin>
              }
            >
              <ul>
                {legacyValue.map((items, valueIndex) => (
                  <li key={valueIndex}>
                    <ul>
                      <li>
                        <Space size="small">
                          {items.map((itemValueTitle, index) => (
                            <Space size="small" key={index}>
                              <FeatherIcon icon={index ? 'arrow-right' : 'chevrons-down'} size={10} />
                              <span>{itemValueTitle}</span>
                            </Space>
                          ))}
                        </Space>
                      </li>
                    </ul>
                  </li>
                ))}
              </ul>
            </Collapse.Panel>
          </Collapse>
        </CollapseContainer>
      )}

      {showModal ? (
        <ModalSelectCustomItem
          listId={listRoot.id}
          root={listRoot}
          handleClose={closeModal}
          selectedItems={listValue}
          parents={[]}
          multiple={field.multiple}
          getListItems={getListItems ?? incidentFormContext?.getListItems}
        />
      ) : null}
    </>
  );
};

CustomListField.defaultProps = {
  getListRoot: CustomListsService.getListRoot,
  getListItems: CustomListsService.getListItems,
};

CustomListField.propTypes = {
  field: PropTypes.shape({
    idInput: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.object,
    typeSelected: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    multiple: PropTypes.bool,
    obligatory: PropTypes.bool,
  }),
  readOnly: PropTypes.bool,
  onChange: PropTypes.func,
  getListRoot: PropTypes.func,
  getListItems: PropTypes.func,
  disabled: PropTypes.bool,
  extendedFormEnabled: PropTypes.bool,
};
